import { atom, useAtom } from 'jotai';

export type WalletNotification = {
	description: string;
	title?: string;
	type: 'error' | 'success';
};

const notificationAtom = atom<undefined | WalletNotification>(undefined);

export const useWalletNotificationAtom = () => {
	const [walletNotification, setWalletNotification] = useAtom(notificationAtom);

	return { setWalletNotification, walletNotification };
};
